import * as React from "react";
import { SVGProps } from "react";

const SvgFiveDiamonds = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 285 398"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M273.4 0H11.5S.5.3.5 14.8v367.6c0 14.5 11 14.8 11 14.8h261.9s11-.3 11-14.8V14.8c0-14.5-11-14.8-11-14.8Z"
      fill="#fff"
    />
    <mask
      id="five-diamonds_svg__b"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={214}
      width={285}
      height={184}
    >
      <path
        d="M168 214.4c-55.8 0-111.6 0-167.3.1v168c0 14.5 11 14.8 11 14.8h261.8s11-.3 11-14.8V214.4H168Z"
        fill="url(#five-diamonds_svg__a)"
      />
    </mask>
    <g mask="url(#five-diamonds_svg__b)">
      <path
        d="M168 214.4c-55.8 0-111.6 0-167.3.1v168c0 14.5 11 14.8 11 14.8h261.8s11-.3 11-14.8V214.4H168Z"
        fill="url(#five-diamonds_svg__c)"
      />
    </g>
    <mask
      id="five-diamonds_svg__e"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={285}
      height={199}
    >
      <path
        d="M.6 198.2c23.9 0 47.8 0 71.7.1 68.8 0 137.7 0 206.5.1h5.7V14.8c0-14.5-11-14.8-11-14.8H11.7S.7.3.7 14.8V198.2H.6Z"
        fill="url(#five-diamonds_svg__d)"
      />
    </mask>
    <g mask="url(#five-diamonds_svg__e)">
      <path
        d="M.6 198.2c23.9 0 47.8 0 71.7.1 68.8 0 137.7 0 206.5.1h5.7V14.8c0-14.5-11-14.8-11-14.8H11.7S.7.3.7 14.8V198.2H.6Z"
        fill="url(#five-diamonds_svg__f)"
      />
    </g>
    <mask
      id="five-diamonds_svg__h"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={5}
      y={0}
      width={280}
      height={398}
    >
      <path
        d="M283.9 14.8V382c0 14.5-11 14.8-11 14.8H10.8s-2.4-.1-4.9-1.6c2.8 2.1 5.8 2.2 5.8 2.2h261.9s11-.3 11-14.8V14.8c0-14.5-11-14.8-11-14.8h-.6c-.1 0 10.9.3 10.9 14.8Z"
        fill="url(#five-diamonds_svg__g)"
      />
    </mask>
    <g mask="url(#five-diamonds_svg__h)">
      <path
        d="M283.9 14.8V382c0 14.5-11 14.8-11 14.8H10.8s-2.4-.1-4.9-1.6c2.8 2.1 5.8 2.2 5.8 2.2h261.9s11-.3 11-14.8V14.8c0-14.5-11-14.8-11-14.8h-.6c-.1 0 10.9.3 10.9 14.8Z"
        fill="url(#five-diamonds_svg__i)"
      />
    </g>
    <mask
      id="five-diamonds_svg__k"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={280}
      height={398}
    >
      <path
        d="M1.2 382.5V15.4C1.2.9 12.2.6 12.2.6h262.1s2.4.1 4.9 1.6C276.4.1 273.4 0 273.4 0H11.5S.5.3.5 14.8v367.6c0 14.5 11 14.8 11 14.8h.6c.1.1-10.9-.2-10.9-14.7Z"
        fill="url(#five-diamonds_svg__j)"
      />
    </mask>
    <g mask="url(#five-diamonds_svg__k)">
      <path
        d="M1.2 382.5V15.4C1.2.9 12.2.6 12.2.6h262.1s2.4.1 4.9 1.6C276.4.1 273.4 0 273.4 0H11.5S.5.3.5 14.8v367.6c0 14.5 11 14.8 11 14.8h.6c.1.1-10.9-.2-10.9-14.7Z"
        fill="url(#five-diamonds_svg__l)"
      />
      <mask
        id="five-diamonds_svg__n"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={28}
        width={2}
        height={344}
      >
        <path
          d="M.6 28.7v342.6l.6-2.1V34.9c-.2-2-.4-4.1-.6-6.2Z"
          fill="url(#five-diamonds_svg__m)"
        />
      </mask>
      <g mask="url(#five-diamonds_svg__n)">
        <path
          d="M.6 28.7v342.6l.6-2.1V34.9c-.2-2-.4-4.1-.6-6.2Z"
          fill="url(#five-diamonds_svg__o)"
        />
      </g>
    </g>
    <path
      d="M34.9 74.3c-7.2-4-12.9-16.1-13.1-16.4-.2.4-5.9 12.5-13.1 16.4 7.2 4 12.9 16.1 13.1 16.4.2-.3 6-12.4 13.1-16.4ZM11.4 51.5v-5.3h3c.5 1.7 1.3 3 2.3 3.8 1 .8 2.3 1.2 3.9 1.2 2.2 0 3.9-.7 5-2s1.7-3.3 1.7-6c0-1.8-.3-3.2-.9-4.4-.6-1.2-1.4-2-2.4-2.5s-2.2-.8-3.6-.8c-1.1 0-2.1.1-2.9.2-.8.1-1.7.4-2.6.7l-2-1.2V18.7h13.8c.6 0 1 0 1.2-.1.3-.1.5-.2.6-.4.2-.2.3-.6.5-1.1h2l-.4 5.8H16.2v11c.9-.4 1.8-.6 2.8-.8 1-.2 2-.3 3.1-.3 2 0 3.8.4 5.3 1.2 1.5.8 2.7 2 3.6 3.5.8 1.5 1.3 3.2 1.3 5.2 0 2.2-.5 4.2-1.4 5.8-.9 1.6-2.3 2.8-4.1 3.7-1.8.8-3.9 1.3-6.3 1.3-2.9-.2-5.9-.8-9.1-2ZM248.4 322.2c7.2 4 12.9 16.1 13.1 16.4.2-.4 5.9-12.5 13.1-16.4-7.2-4-12.9-16.1-13.1-16.4-.1.3-5.9 12.4-13.1 16.4ZM272 344.9v5.3h-3c-.5-1.7-1.3-3-2.3-3.8-1-.8-2.3-1.2-3.9-1.2-2.2 0-3.9.7-5 2s-1.7 3.3-1.7 6c0 1.8.3 3.2.9 4.4.6 1.2 1.4 2 2.4 2.5s2.2.8 3.6.8c1.1 0 2.1-.1 2.9-.2.8-.1 1.7-.4 2.6-.7l2 1.2v16.5h-13.8c-.6 0-1 0-1.2.1-.3.1-.5.2-.6.4-.2.2-.3.6-.5 1.1h-2l.4-5.8h14.4v-11c-.9.4-1.8.6-2.8.8-1 .2-2 .3-3.1.3-2 0-3.8-.4-5.3-1.2-1.5-.8-2.7-2-3.6-3.5-.8-1.5-1.3-3.2-1.3-5.2 0-2.2.5-4.2 1.4-5.8.9-1.6 2.3-2.8 4.1-3.7 1.8-.8 3.9-1.3 6.3-1.3 2.9.3 5.9.8 9.1 2ZM116.1 317.8c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.2 7.9 25.7 31.9 26 32.6.3-.7 11.7-24.7 26-32.6ZM116.1 79.5c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.2 7.9 25.7 31.9 26 32.6.3-.7 11.7-24.7 26-32.6ZM221 317.8c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.2 7.9 25.7 31.9 26 32.6.3-.7 11.7-24.7 26-32.6ZM221 79.5c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.2 7.9 25.7 31.9 26 32.6.3-.7 11.7-24.7 26-32.6ZM168.5 198.7c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.3 7.9 25.7 31.9 26 32.6.4-.8 11.8-24.7 26-32.6Z"
      fill="#FF2601"
    />
    <defs>
      <radialGradient
        id="five-diamonds_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(138.136 -135.451) scale(574.543)"
      >
        <stop offset={0.616} />
        <stop offset={0.752} stopColor="#020202" />
        <stop offset={0.804} stopColor="#090909" />
        <stop offset={0.841} stopColor="#151515" />
        <stop offset={0.872} stopColor="#262626" />
        <stop offset={0.899} stopColor="#3C3C3C" />
        <stop offset={0.922} stopColor="#585858" />
        <stop offset={0.944} stopColor="#797979" />
        <stop offset={0.963} stopColor="#9F9F9F" />
        <stop offset={0.982} stopColor="#CBCBCB" />
        <stop offset={0.998} stopColor="#F9F9F9" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="five-diamonds_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(138.136 -135.451) scale(574.543)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.788} stopColor="#FDFDFD" />
        <stop offset={0.854} stopColor="#F6F6F6" />
        <stop offset={0.901} stopColor="#EAEAEA" />
        <stop offset={0.94} stopColor="#D9D9D9" />
        <stop offset={0.974} stopColor="#C3C3C3" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="five-diamonds_svg__d"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(143.821 366.656) scale(411.697)"
      >
        <stop offset={0.616} />
        <stop offset={0.71} stopColor="#020202" />
        <stop offset={0.762} stopColor="#0A0A0A" />
        <stop offset={0.805} stopColor="#181818" />
        <stop offset={0.842} stopColor="#2C2C2C" />
        <stop offset={0.875} stopColor="#464646" />
        <stop offset={0.906} stopColor="#656565" />
        <stop offset={0.935} stopColor="#8A8A8A" />
        <stop offset={0.963} stopColor="#B6B6B6" />
        <stop offset={0.988} stopColor="#E5E5E5" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="five-diamonds_svg__f"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(143.821 366.656) scale(411.697)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.747} stopColor="#FDFDFD" />
        <stop offset={0.821} stopColor="#F5F5F5" />
        <stop offset={0.88} stopColor="#E7E7E7" />
        <stop offset={0.932} stopColor="#D3D3D3" />
        <stop offset={0.978} stopColor="#BABABA" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="five-diamonds_svg__g"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-11.515 -.179) scale(457.129)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="five-diamonds_svg__i"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-11.515 -.179) scale(457.129)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="five-diamonds_svg__j"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(78.146 115.635) scale(389.35)"
      >
        <stop />
        <stop offset={0.007} stopColor="#090909" />
        <stop offset={0.048} stopColor="#373737" />
        <stop offset={0.093} stopColor="#626262" />
        <stop offset={0.142} stopColor="#888" />
        <stop offset={0.195} stopColor="#A8A8A8" />
        <stop offset={0.254} stopColor="#C4C4C4" />
        <stop offset={0.32} stopColor="#DADADA" />
        <stop offset={0.397} stopColor="#EBEBEB" />
        <stop offset={0.493} stopColor="#F6F6F6" />
        <stop offset={0.627} stopColor="#FDFDFD" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="five-diamonds_svg__l"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(78.146 115.635) scale(389.35)"
      >
        <stop stopColor="#fff" />
        <stop offset={0.141} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="five-diamonds_svg__m"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-456.906 0 0 -456.924 296.205 -.18)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="five-diamonds_svg__o"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-456.906 0 0 -456.924 296.205 -.18)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
    </defs>
  </svg>
);

export default SvgFiveDiamonds;
